export enum GeoEnum {
  KZ = 'KZ',
  KG = 'KG',
  UZ = 'UZ',
  TJ = 'TJ',
}
